<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle>Explore Guide</h2>
    <div contentContainer>
        <div style="background-position-x: center;background-repeat: no-repeat; min-height: 250px; background-size: 45%; text-align: center; background-image: url(&quot;//res.cloudinary.com/dnjrorsut/image/upload/v1593677492/70834/yxpovyt5ry3uj4tolfte.png&quot;);"></div>
        <div class="container text-center">
            <div>
                <h1>Welcome to Agora meeting</h1>
            </div>
            <div>
                <h2>Effective Meeting Without Hassle!</h2>
            </div>
            <div>
                <h3>Revamp the way you have meetings with powerful electronic tools to facilitate meetings.</h3>
            </div>
        </div>
    </div>
    <div actions class="col-md-12 text-center">
        <button mat-dialog-close mat-raised-button class="primary" (click) = "triggerTour()" style="color: white; border-radius: 20px;">Start Tour</button>
    </div>
</app-centre-small-opener>